


<app-header [username]="username"></app-header>
<router-outlet (activate)=subscribetologin($event) (deactivate)="unsubcribelogin()"></router-outlet>
<app-footer></app-footer>